import type { Qubic, Subscription } from "api";
import { StatusTag } from "components/ui/StatusTag";
import { UsageBlock } from "components/ui/UsageBlock";
import { cubeUrl } from "constants/products.constants";
import { formatDate } from "utils/date.utils";
import { limitNotice } from "./myqubics.model";

type MyQubicsRowProps = {
  subscription: Subscription;
  product: Qubic | undefined;
};

const ErrorIcon = () => (
  <svg
    className="pc-err__ico"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <line x1="12" y1="7" x2="12" y2="13" />
    <line x1="12" y1="16.5" x2="12" y2="16.5" />
  </svg>
);

/**
 * One tool the company holds. The design's "Total volume" and Test/Production
 * key tag are left out: contracts and key environments are not modelled, so
 * there is nothing true to put in them.
 */
export const MyQubicsRow = ({ subscription, product }: MyQubicsRowProps) => {
  const notice = limitNotice(subscription);
  const { upgrade_url: upgradeUrl } = subscription.limit;

  return (
    <div className="pcx">
      <div className="pc-agr">
        <div className="pc-agrp">
          <div className="pc-agrp__row">
            <div className="pc-agrp__p">
              {product && <img className="pccube" src={cubeUrl(product.cube)} alt="" width={30} height={30} />}
              <b>{product?.name ?? subscription.label}</b>
            </div>

            <div className="pc-agrp__st">
              <StatusTag status={subscription.status} />
            </div>

            {subscription.expires_at !== null && (
              <div className="pc-agrp__f pc-agrp__f--exp">
                <span>Expires</span>
                <b>{formatDate(subscription.expires_at)}</b>
              </div>
            )}

            <div className="pc-agrp__use">
              <UsageBlock
                subscription={subscription}
                buyUrl={upgradeUrl}
                notice={
                  notice && (
                    <div className="pc-err" role="alert">
                      <div className="pc-err__top">
                        <ErrorIcon />
                        <div>
                          <div className="pc-err__h">{notice.title}</div>
                          <p className="pc-err__t">{notice.text}</p>
                        </div>
                      </div>
                      <div className="pc-key__acts">
                        <a className="pcbtn pcbtn--main" href={upgradeUrl} target="_blank" rel="noopener noreferrer">
                          Upgrade limit
                        </a>
                      </div>
                    </div>
                  )
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
